/**
 * The maximum safe integer in JavaScript, as defined by `Number.MAX_SAFE_INTEGER` (2^53 - 1).
 * Used as the upper bound for safe integer operations.
 */
export const MAX_NUMBER = Number.MAX_SAFE_INTEGER;

/**
 * The minimum safe integer in JavaScript, as defined by `Number.MIN_SAFE_INTEGER` (-(2^53 - 1)).
 * Used as the lower bound for safe integer operations.
 */
export const MIN_NUMBER = Number.MIN_SAFE_INTEGER;
